import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { CommonInput, CommonSelect, CommonButton } from "../Input";
import DataTable from "../table/DataTable";
import IndividualCustomerModal from "./IndividualCustomerModal";
import OrganizationCustomerModal from "./OrganizationCustomerModal";
import CustomerDetailsModal from "./CustomerDetailsModal";

const CustomerList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [name, setName] = useState("");
  const [idCard, setIdCard] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [nationality, setNationality] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [customerType, setCustomerType] = useState(null);
  const [showIndividualModal, setShowIndividualModal] = useState(false);
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const nationalityOptions = [
    { value: "Singaporean", label: "Singaporean" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Korean", label: "Korean" },
    { value: "American", label: "American" },
  ];

  const balanceOptions = [
    { value: "0-100", label: "0 - 100 SGD" },
    { value: "100-1000", label: "100 - 1000 SGD" },
    { value: "1000-5000", label: "1000 - 5000 SGD" },
    { value: "5000-999999999", label: "5000+ SGD" },
  ];

  const typeOptions = [
    { value: "individual", label: "Individual" },
    { value: "organization", label: "Organization" },
  ];

  const columns = [
    { label: "User ID", key: "id" },
    {
      label: "Name",
      key: "name",
      render: (item) => <span className="fw-bold">{item.name}</span>,
    },
    {
      label: "Type",
      key: "type",
      render: (item) => (
        <Badge
          className="fw-bold"
          bg={item.type === "Organization" ? "dark" : "primary"}
          style={{
            color: item.type === "Organization" ? "#fff" : "#475467",
            borderRadius: "20px",
            fontSize: "11px",
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "ID Card Number", key: "idCard" },
    {
      label: "Available balance",
      key: "availableBalance",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Pending balance",
      key: "pendingBalance",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Status",
      key: "status",
      render: (item) => (
        <Badge
          bg="none"
          className="px-3 py-2 fw-bold"
          style={{
            backgroundColor: "#E1F9ED",
            color: "#28C76F",
            borderRadius: "6px",
            fontSize: "11px",
            textTransform: "uppercase",
          }}
        >
          {item.status}
        </Badge>
      ),
    },
    {
      label: "KYC Status",
      key: "kycStatus",
      render: (item) => (
        <Badge
          bg="none"
          className="px-3 py-2 fw-bold"
          style={{
            backgroundColor:
              item.kycStatus === "APPROVED" ? "#E1F9ED" : "#FFF3E0",
            color: item.kycStatus === "APPROVED" ? "#28C76F" : "#FF9F43",
            borderRadius: "6px",
            fontSize: "11px",
            textTransform: "uppercase",
          }}
        >
          {item.kycStatus}
        </Badge>
      ),
    },
    {
      label: "Created Time",
      key: "createdTime",
      cellStyle: () => ({ whiteSpace: "pre-line" }),
    },
    {
      label: "Actions",
      className: "text-center pe-4",
      render: (item) => (
        <button
          className="btn btn-link p-0 text-muted text-center w-100"
          onClick={() => {
            setSelectedCustomer(item);
            setShowDetailsModal(true);
          }}
        >
          <i className="far fa-eye text-dark fs-16"></i>
        </button>
      ),
    },
  ];

  const mockData = [
    {
      id: "10844",
      name: "SparkMinds Technology Pte Ltd",
      type: "Organization",
      email: "checkpast12month@yopmail.com",
      phone: "+84 765161894",
      idCard: "S1234567A013",
      availableBalance: "200 SGD\n0 USD",
      pendingBalance: "0 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n18:23:59",
      // Personal Information (Main Contact)
      fullName: "Quang Nguyen",
      dob: "02/07/1997",
      nationality: "Singaporean",
      jobTitle: "Software Developer",
      residentialAddress: "24A Bau Cat Street, Ward 14, Tan Binh District",
      // Organization Information
      registeredName: "SparkMinds Technology Pte Ltd",
      uen: "11129001",
      entityType: "Private Limited Company",
      incorporationDate: "01/08/2021",
      businessActivity: "Software Development and IT Consulting",
      officePhone: "+84 765161894",
      primaryEmail: "info@sparkminds.com",
      localBranches: "2",
      overseasBranches: "1",
      overseasCountries: "Vietnam",
      // Organization Address
      country: "Singapore",
      city: "Singapore",
      addressLine1: "10 Anson Road",
      addressLine2: "#15-14 International Plaza",
      postalCode: "079903",
      // ID Information
      idType: "NRIC (Permanent Resident)",
      idNumber: "S1234567A013",
      idExpiryDate: "03/07/2028",
      beneficialOwners: [
        {
          name: "John Smith",
          dob: "15/03/1980",
          nationality: "Singaporean",
          idType: "Passport",
          idNumber: "A12345678",
          expiryDate: "15/03/2030",
          address: "123 Orchard Road, Singapore",
          interest: "60",
        },
        {
          name: "Mary Johnson",
          dob: "20/11/1975",
          nationality: "Filipino",
          idType: "Passport",
          idNumber: "T9876543B",
          expiryDate: "20/11/2029",
          address: "456 Marina Bay, Singapore",
          interest: "40",
        },
      ],
      // Wallet Balance Table
      wallets: [
        { currency: "SGD", available: "200.00", pending: "0.00" },
        { currency: "USD", available: "1,500.00", pending: "500.00" }
      ],
      // Usage Limits Table
      usageLimits: [
        { type: "Organization", daily: "0 / -", monthly: "50 / -", yearly: "600 / -", past30: "5 / 250,000", past12: "60 / 1,200,000", color: "inherit" },
      ],
      // Documents
      documents: [
        { label: "Business License", image: "https://via.placeholder.com/150" },
        { label: "Tax Registration", image: "https://via.placeholder.com/150" }
      ],
      history: [
        {
          id: "TX100",
          dateTime: "10/03/2026\n14:00:00",
          senderName: "SparkMinds",
          senderEmail: "checkpast12month@yopmail.com",
          receiverName: "Alice Wong",
          paymentMethod: "Bank Transfer",
          sendAmount: "1,200.00 SGD",
          status: "Approved",
        },
      ],
    },
    {
      id: "10843",
      name: "Thuy Nga Phan",
      type: "Individual",
      email: "individual@yopmail.com",
      phone: "+84 789908092",
      idCard: "check12month",
      availableBalance: "856,714 SGD\n0 USD",
      pendingBalance: "7,042,05 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n11:38:29",
      // Personal Information
      firstName: "Thuy",
      middleName: "Nga",
      lastName: "Phan",
      dob: "20/05/1990",
      nationality: "Filipino",
      countryOfBirth: "American Samoa",
      gender: "Male",
      occupation: "Driver",
      // Contact Information
      // (email and phone already present in root)
      // Address Information
      country: "Philippines",
      city: "Singapore",
      addressLine1: "123 Orchard Road",
      addressLine2: "Unit 45-67",
      postalCode: "12345",
      // ID Information
      idType: "Passport",
      idNumber: "check12month",
      idIssueDate: "15/01/2018",
      idExpiryDate: "15/01/2028",
      // EKYC Information
      amlScore: "-",
      amlRiskRating: "-",
      ekycStatus: "-",
      // Wallet Balance Table
      wallets: [
        { currency: "SGD", available: "856,714", pending: "7,042,05" }
      ],
      // Usage Limits Table
      usageLimits: [
        { type: "Organization", daily: "0 / -", monthly: "23 / -", yearly: "23 / -", past30: "23 / 1,123,123,123", past12: "23 / -", color: "red" },
        { type: "Individual", daily: "0 / -", monthly: "12 / -", yearly: "12 / -", past30: "12 / 1,123,123,123", past12: "12 / -", color: "red" },
      ],
      // Documents
      documents: [
        { label: "Front of ID Card", image: "https://via.placeholder.com/150" },
        { label: "Back of ID Card", image: "https://via.placeholder.com/150" },
        { label: "Proof of Address", image: "https://via.placeholder.com/150" }
      ],
      history: [
        {
          id: "TX101",
          dateTime: "08/03/2026\n09:30:00",
          senderName: "Thuy Nga Phan",
          senderEmail: "individual@yopmail.com",
          receiverName: "Bui Van C",
          paymentMethod: "Cash",
          sendAmount: "500.00 SGD",
          status: "Approved",
        },
      ],
    },
    {
      id: "10842",
      name: "idjaoida",
      type: "Organization",
      email: "judhuiajhdoa@yopmail.com",
      phone: "+65 93213213",
      idCard: "154651651",
      availableBalance: "-",
      pendingBalance: "-",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "05/03/2026\n10:41:31",
      // Detail Fields
      fullName: "Officer John",
      dob: "10/10/1985",
      nationality: "Singaporean",
      jobTitle: "Business Owner",
      residentialAddress: "123 Serangoon Road",
      registeredName: "idjaoida Business",
      uen: "REG456789",
      entityType: "Partnership",
      incorporationDate: "20/05/2020",
      businessActivity: "Retail Trade",
      officePhone: "+65 93213213",
      primaryEmail: "judhuiajhdoa@yopmail.com",
      country: "Singapore",
      city: "Singapore",
      addressLine1: "123 Serangoon Road",
      addressLine2: "#05-10",
      postalCode: "123456",
      idType: "UEN",
      idNumber: "154651651",
      idExpiryDate: "20/05/2030",
      beneficiaries: [],
      history: [],
    },
    {
      id: "10841",
      name: "Alpha Corp Solution",
      type: "Organization",
      email: "alpha@corp.com",
      phone: "+65 67891234",
      idCard: "UEN998877",
      availableBalance: "50,000 SGD",
      pendingBalance: "2,000 SGD",
      status: "DEACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "01/03/2026\n08:00:00",
      fullName: "Robert Chen",
      dob: "12/12/1980",
      nationality: "Singaporean",
      jobTitle: "Director",
      registeredName: "Alpha Corp Solution Pte Ltd",
      uen: "99887766A",
      entityType: "Private Limited",
      country: "Singapore",
      city: "Singapore",
      addressLine1: "50 Raffles Place",
      postalCode: "048623",
      idType: "Passport",
      idNumber: "E1234567B",
      idExpiryDate: "12/12/2030",
      beneficiaries: [
        {
          id: "B101",
          name: "Alpha Admin",
          contactNo: "+65 88887777",
          receiverType: "Organization",
          relationship: "Subsidiary",
          bank: "OCBC Bank",
          deliveryMethod: "Bank Transfer",
          createdDate: "02/03/2026\n11:00:00",
          status: "Active",
          details: {
            country: "Singapore",
            currency: "SGD",
            relationship: "Subsidiary",
            idType: "UEN",
            idNumber: "123456789",
            dob: "01/01/2010",
            firstName: "Alpha",
            lastName: "Admin",
            contactNumber: "+65 88887777",
            address: "50 Raffles Place",
            city: "Singapore",
            bankName: "OCBC Bank",
            accountNumber: "999888777",
            accountType: "Current",
            bankAccountTitle: "Alpha Corp Solution Admin",
            ifscNumber: "OCBC001",
            swiftCode: "OCBCSGSG",
          },
        },
      ],
      history: [
        {
          id: "TX555",
          dateTime: "05/03/2026\n16:45:00",
          senderName: "Alpha Corp",
          senderEmail: "alpha@corp.com",
          receiverName: "Alpha Admin",
          paymentMethod: "Internal",
          sendAmount: "5,000.00 SGD",
          status: "Approved",
        },
      ],
    },
    {
      id: "10840",
      name: "Lee Min Ho",
      type: "Individual",
      email: "minho@kmail.com",
      phone: "+82 1012345678",
      idCard: "KOR990011",
      availableBalance: "10,500 SGD",
      pendingBalance: "0 SGD",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "28/02/2026\n15:20:00",
      fullName: "Lee Min Ho",
      dob: "22/06/1987",
      nationality: "Korean",
      jobTitle: "Actor",
      residentialAddress: "Gangnam-gu, Seoul",
      country: "South Korea",
      city: "Seoul",
      addressLine1: "123 K-Star Road",
      postalCode: "06017",
      idType: "National ID",
      idNumber: "990011-1234567",
      idExpiryDate: "22/06/2035",
      beneficiaries: [],
      history: [
        {
          id: "TX999",
          dateTime: "01/03/2026\n12:00:00",
          senderName: "Lee Min Ho",
          senderEmail: "minho@kmail.com",
          receiverName: "K-Ent Agency",
          paymentMethod: "Bank Transfer",
          sendAmount: "2,500.00 SGD",
          status: "Approved",
        },
      ],
    },
    {
      id: "10839",
      name: "Global Trading Co",
      type: "Organization",
      email: "trade@global.com",
      phone: "+1 2025550123",
      idCard: "US-TRD-4455",
      availableBalance: "1,000,000 USD",
      pendingBalance: "50,000 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "25/02/2026\n10:10:00",
      fullName: "Sarah Johnson",
      dob: "05/05/1975",
      nationality: "American",
      jobTitle: "CEO",
      registeredName: "Global Trading Co LLC",
      uen: "TRD-887766",
      entityType: "LLC",
      country: "USA",
      city: "Washington D.C.",
      addressLine1: "1600 Pennsylvania Avenue",
      postalCode: "20500",
      idType: "Tax ID",
      idNumber: "44-556677",
      idExpiryDate: "05/05/2045",
      beneficiaries: [
        {
          id: "B500",
          name: "Logistics Pro",
          contactNo: "+1 3034441234",
          receiverType: "Organization",
          relationship: "Vendor",
          bank: "Chase Bank",
          deliveryMethod: "SWIFT",
          createdDate: "26/02/2026\n09:00:00",
          status: "Active",
          details: {
            country: "USA",
            currency: "USD",
            relationship: "Vendor",
            idType: "Tax ID",
            idNumber: "99-888777",
            firstName: "Logistics",
            lastName: "Pro LLC",
            contactNumber: "+1 3034441234",
            address: "100 Industrial Way",
            city: "Denver",
            state: "Colorado",
            bankName: "Chase Bank",
            accountNumber: "555666777",
            accountType: "Business",
            bankAccountTitle: "Logistics Pro LLC",
            routingNumber: "123456789",
            swiftCode: "CHASUS33",
          },
        },
      ],
      history: [
        {
          id: "TX111",
          dateTime: "27/02/2026\n11:30:00",
          senderName: "Global Trading",
          senderEmail: "trade@global.com",
          receiverName: "Logistics Pro",
          paymentMethod: "SWIFT",
          sendAmount: "10,000.00 USD",
          status: "Approved",
        },
      ],
    },
  ];

  const [filteredData, setFilteredData] = useState(mockData);

  const handleSearch = () => {
    let result = mockData.filter((item) => {
      const matchName = name
        ? item.name.toLowerCase().includes(name.toLowerCase())
        : true;
      const matchId = idCard
        ? item.idCard.toLowerCase().includes(idCard.toLowerCase())
        : true;
      const matchPhone = phone
        ? item.phone.toLowerCase().includes(phone.toLowerCase())
        : true;
      const matchEmail = email
        ? item.email.toLowerCase().includes(email.toLowerCase())
        : true;
      const matchType = customerType
        ? item.type.toLowerCase() === customerType.value.toLowerCase()
        : true;

      // Nationality Filter
      let matchNationality = true;
      if (nationality && item.nationality) {
        matchNationality = item.nationality.toLowerCase().includes(nationality.value.toLowerCase());
      }

      // Wallet Balance Filter
      let matchBalance = true;
      if (walletBalance && item.availableBalance && item.availableBalance !== "-") {
        // Extract the first number (assuming SGD) from string like "200 SGD\n0 USD"
        const sgdMatch = item.availableBalance.match(/[\d,.]+/);
        if (sgdMatch) {
          const balance = parseFloat(sgdMatch[0].replace(/,/g, ""));
          const [min, max] = walletBalance.value.split("-").map(Number);
          matchBalance = balance >= min && balance <= max;
        } else {
          matchBalance = false;
        }
      }

      return (
        matchName &&
        matchId &&
        matchPhone &&
        matchEmail &&
        matchType &&
        matchNationality &&
        matchBalance
      );
    });
    setFilteredData(result);
  };

  const handleReset = () => {
    setName("");
    setIdCard("");
    setPhone("");
    setEmail("");
    setNationality(null);
    setWalletBalance(null);
    setCustomerType(null);
    setFilteredData(mockData);
  };

  return (
    <div className="container-fluid">
      <div className="form-head mb-4 d-flex align-items-center justify-content-between">
        <h2 className="fw-bold text-black mb-0 fs-24">Customers</h2>
        <div className="d-flex g-2">
          <CommonButton
            className="me-2"
            onClick={() => setShowIndividualModal(true)}
          >
            Create Individual Customer
          </CommonButton>
          <CommonButton onClick={() => setShowOrganizationModal(true)}>
            Create Organization Customer
          </CommonButton>
        </div>
      </div>

      <div className="card mb-4" style={{ borderRadius: "10px" }}>
        <div className="card-body p-3">
          <div className="row g-2 align-items-end">
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonInput
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonInput
                placeholder="Enter ID Card No"
                value={idCard}
                onChange={(e) => setIdCard(e.target.value)}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonSelect
                placeholder="Select nationality"
                options={nationalityOptions}
                value={nationality}
                onChange={setNationality}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonInput
                placeholder="Enter phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonInput
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonSelect
                placeholder="Select wallet balance"
                options={balanceOptions}
                value={walletBalance}
                onChange={setWalletBalance}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <CommonSelect
                placeholder="Select customer type"
                options={typeOptions}
                value={customerType}
                onChange={setCustomerType}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 text-end">
              <div className="d-flex gap-2">
                <CommonButton
                  variant="outline"
                  onClick={handleReset}
                  className="p-0 d-flex align-items-center justify-content-center"
                >
                  <i className="flaticon-381-repeat-1"></i>
                </CommonButton>
                <CommonButton
                  onClick={handleSearch}
                  className="p-0 d-flex align-items-center justify-content-center"
                >
                  <i className="flaticon-381-search-1 fs-18"></i>
                </CommonButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card" style={{ borderRadius: "10px" }}>
        <div className="card-body ">
          <DataTable
            data={filteredData}
            columns={columns}
            totalItems={filteredData.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={setCurrentPage}
            minWidth="1200px"
          />
        </div>
      </div>

      <IndividualCustomerModal
        show={showIndividualModal}
        onHide={() => setShowIndividualModal(false)}
      />
      <OrganizationCustomerModal
        show={showOrganizationModal}
        onHide={() => setShowOrganizationModal(false)}
      />
      <CustomerDetailsModal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        customer={selectedCustomer}
      />
    </div>
  );
};

export default CustomerList;
